export enum FactorType {
    PHONE_NUMBER = 'phone_number',
    EMAIL = 'email',
}
